import { useMemo } from 'react';

export const normalizeFilters = <T extends { order?: number }>(
  items: Record<string, T> | T[] | undefined
): T[] => {
  if (!items) return [];
  if (Array.isArray(items)) return items;
  return Object.values(items).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
};

export const useNormalizeFilters = <T extends { order?: number }>(
  items: Record<string, T> | T[]
) => useMemo(() => normalizeFilters(items), [items]);
